import { ReactNode } from "react";
import { Container } from "../../elements/Container";
import { Image } from "../../elements/Image";
import { styles } from "./SampleVhrComponent.style";

export interface SampleVhrComponentProps {
  imageSource: {
    url: string;
    width?: number;
    height?: number;
    title?: string;
  };
  alt: string;
  title: string;
  text?: ReactNode;
  children: ReactNode;
  isDesktop: boolean;
}

export const SampleVhrComponent = (props: SampleVhrComponentProps) => {
  const { imageSource, title, text = "", children, isDesktop } = props;
  const renderTitle = () => {
    return (
      <div className={styles.titleWrapper()}>
        <h2>{title}</h2>
      </div>
    );
  };

  const renderImage = () => {
    return (
      <div className={styles.imageWrapper()}>
        <Image image={imageSource} />
      </div>
    );
  };
  const renderDesktopSampleVhr = () => {
    return (
      <Container>
        <div className={styles.contentWrapper()}>
          {renderImage()}
          <div className={styles.textWrapper()}>
            {renderTitle()}
            <div className={styles.subtitleWrapper()}>{text}</div>
            {children}
          </div>
        </div>
      </Container>
    );
  };
  const renderMobileSampleVhr = () => {
    return (
      <Container>
        <div className={styles.contentWrapper()}>
          <div className={styles.textWrapper()}>
            {renderTitle()}
            {renderImage()}
            <div className={styles.subtitleWrapper()}>{text}</div>
            {children}
          </div>
        </div>
      </Container>
    );
  };

  return isDesktop ? renderDesktopSampleVhr() : renderMobileSampleVhr();
};
